import { useDispatch } from 'react-redux';
import { IRootDispatch } from '../store/models';
import { SnackbarState } from '../store/Snackbar.model';

export type SnackbarFunctions = {
  openSnackbar: (state: Partial<SnackbarState>) => void,
  closeSnackbar: (payload?: { transition?: string }) => void,
};

/**
 * A hook for accessing functionality to open and close a snackbar.
 */
export default function useSnackbar(): SnackbarFunctions {
  const dispatch = useDispatch<IRootDispatch>();

  return {
    openSnackbar: dispatch.snackbar.open,
    closeSnackbar: dispatch.snackbar.close,
  };
}
